module.exports = __webpack_public_path__ + "img/googleplay_logo.0964835d.svg";